import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { ProfileInvitesState } from './profile-invites.state';
import { ProfileInvitesStore } from './profile-invites.store';

@Injectable({ providedIn: 'root' })
export class ProfileInvitesQuery extends QueryEntity<ProfileInvitesState> {
  constructor(protected readonly store: ProfileInvitesStore) {
    super(store);
  }
}
